module.exports = __webpack_public_path__ + "media/images/homes/restaurant-6fada2ad6d50c2a0e9c460a1f38d814f.png";